import ModalTable from './ModalTable';

export default ModalTable;
